export enum OriginationSourceModalModes {
  CREATE = "create",
  EDIT = "edit",
  VIEW = "view",
}
